/**
 * Default configuration constants for the stackable overlay system.
 *
 * Both modals and drawers use custom Tailwind-based implementations. Both
 * share the same z-index stacking strategy so they can be freely interleaved.
 */

export const OVERLAY_SIZES = {
  SM: "SM",
  MD: "MD",
  LG: "LG",
  XL: "XL",
};

/** Modal width mapping (matches legacy MODAL_SIZES breakpoints) */
export const MODAL_WIDTH_MAP = {
  [OVERLAY_SIZES.SM]: "672px",
  [OVERLAY_SIZES.MD]: "896px",
  [OVERLAY_SIZES.LG]: "1024px",
  [OVERLAY_SIZES.XL]: "1280px",
};

/** Drawer width mapping */
export const DRAWER_WIDTH_MAP = {
  [OVERLAY_SIZES.SM]: "384px",
  [OVERLAY_SIZES.MD]: "448px",
  [OVERLAY_SIZES.LG]: "672px",
  [OVERLAY_SIZES.XL]: "896px",
};

/**
 * Base z-index for the overlay system.
 * Sits above the legacy modal z-index (2 300 000 000) so new-system overlays
 * always render on top of legacy ones.
 */
export const OVERLAY_BASE_Z_INDEX = 2350000000;

/** Z-index increment per stacked overlay */
export const OVERLAY_Z_INDEX_STEP = 10;

/** Transition duration (ms) for modal close animation */
export const MODAL_CLOSE_DURATION = 200;

/** Transition duration (ms) for drawer slide-in / slide-out and backdrop fade */
export const DRAWER_TRANSITION_DURATION = 500;
